import {JSXElement} from "../../helpers/react.js";
import {getQueryMap} from "../../helpers/functions.js";
import {ISelectValue} from "../elements/Select.js";

export default abstract class AbstractFiltersForm<T, Data, GetParams> extends JSXElement<{}>{


    protected params = getQueryMap<GetParams>(new URL(location.href).search);

    protected filters: Data = {} as Data
    protected buildParams(){
        const dataBuilder = new URLSearchParams({show_filter: '1'});
        $(this.element).parents('form.filter-block').serializeArray().forEach(function (e) {
            if (e.value) {
                dataBuilder.append(e.name, e.value);
            }
        });
        return dataBuilder;
    }

    abstract filter(this: never): Promise<any>;


    protected get urlPath(){return new URL(location.href).pathname;}
    protected onSelectChange(name: keyof Data){
        return (...values: ISelectValue[]) => {
            if(!values.length)
                delete this.filters[name];
            // const val = values.map(e=>e.value).join(',');
            else (this.filters[name] as any) = values.map(e=>e.value) as any;
        }
    }
    protected onVariableChange(name: keyof Data){
        return (value: string|undefined|number) => {
            if(value === undefined)
                delete this.filters[name];
            else (this.filters[name] as any) = value;
        }
    }
}